import React from "react"
import { errorMessage } from "./input.module.css"

export const ErrorMessage = ( { name, input } ) => {
  const error = ( Object.keys( input.errors ).includes( name ) ) && input.errors[ name ]

  return (
    <div className={ errorMessage }>
      { error }
    </div>
  )
}

export default ErrorMessage